import Highcharts from 'highcharts';
import { filterByCategory } from "./data";

export function getEmploymentData() {
    const categories = [
        'Etaty: liczba strażników',
        'Etaty: Nieobsadzone wakaty strażników',
        'Etaty: Mediana wynagrodzeń\u00A0strażników brutto',
        'Liczba etatów ogółem'
    ];
    const data = filterByCategory(categories);

    data.forEach(sm => {
         // Vacancies
         sm.guards = sm['Etaty: liczba strażników'] || 0;
         const vacancies = sm['Etaty: Nieobsadzone wakaty strażników'] || 0;
         // Assuming authorized guard posts = filled + vacancies
         const totalAuthorizedGuards = sm.guards + vacancies;
         
         sm.vacancyRate = totalAuthorizedGuards > 0 ? Math.round((vacancies / totalAuthorizedGuards) * 100 * 10) / 10 : 0;
         sm.filledGuards = sm.guards;
         sm.vacantGuards = vacancies;

         // Salaries
         sm.salary = sm['Etaty: Mediana wynagrodzeń\u00A0strażników brutto'];

         // Civilians
         // Assuming 'Liczba etatów ogółem' refers to total FILLED posts (guards + civilians)
         const totalFilledPosts = sm['Liczba etatów ogółem'];
         
         if (totalFilledPosts && sm.guards) {
             const civilians = Math.max(0, totalFilledPosts - sm.guards);
             sm.civilians = Math.round(civilians * 10) / 10;
             sm.civilianRatio = Math.round((civilians / totalFilledPosts) * 100 * 10) / 10;
             sm.guardRatio = Math.round((sm.guards / totalFilledPosts) * 100 * 10) / 10;
             sm.totalFilled = totalFilledPosts;
         } else {
             sm.civilians = null;
             sm.civilianRatio = null;
             sm.guardRatio = null;
             sm.totalFilled = null;
         }
    });

    return data;
}

export default function chartSalaries(id) {
    if (!document.getElementById(id)) return;

    // Filter out cities with null salary and sort
    const cityData = getEmploymentData()
        .filter(item => item.salary !== null)
        .sort((a, b) => b.salary - a.salary);

    const categories = cityData.map(item => item.city);
    const salaries = cityData.map(item => item.salary);

    const salaryData = cityData.map(item => {return { salary: item.salary, guards: item.guards } })
        .filter(item => item.salary !== null)
    
    const sumOfGuards = salaryData.reduce((sum, item) => sum + item.guards, 0);
    const sumOfSalaries = salaryData.reduce((sum, item) => sum + item.guards * item.salary, 0);
    const averageSalary = sumOfSalaries / sumOfGuards;

    const barColor = '#2ecc71';
    const belowAvgColor = '#43845e';

    const salariesWithColor = salaries.map(item => ({
        y: item,
        color: item >= averageSalary ? barColor : belowAvgColor
    }));

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Mediana wynagrodzeń brutto strażników' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            min: 0,
            title: { text: 'PLN', align: 'high' },
            labels: { overflow: 'justify' },
            plotLines: [{
                value: averageSalary,
                color: '#2ecc71',
                dashStyle: 'ShortDot',
                width: 3,
                zIndex: 5,
                label: {
                    text: `Średnia: ${averageSalary.toFixed(0)} zł`,
                    align: 'right',
                    verticalAlign: 'bottom',
                    style: { color: '#104c29', fontWeight: 'bold' }
                }
            }]
        },
        tooltip: {
            valueSuffix: ' PLN'
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true,
                    format: '{point.y} zł'
                },
                borderRadius: 4
            }
        },
        legend: { enabled: false },
        credits: { enabled: false },
        series: [{
            name: 'Mediana wynagrodzeń',
            data: salariesWithColor,
            color: '#2ecc71'
        }]
    });
}
